import { ospThemes, Icon } from "@ospweb/sdk-ui";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/CoPilot/CopilotAgent/TrackerEmptyTip";

const I18n = I18nUtil.createScoped(Translations);

export const TrackerEmptyTip = () => {
  return (
    <div
      className="flex flex-col md:flex-row md:justify-between md:items-center gap-1 md:gap-0 p-4 rounded-3 bg-background_brand_overlay10"
      data-tracking-scope="tracker-empty-tip"
    >
      <div className="flex items-center gap-1">
        <Icon
          name="portfolio_solid"
          size={20}
          color={ospThemes.colors.content_primary}
        />
        <span className="title_l text-content_primary">
          {I18n.t("Portfolio Tracker")}
        </span>
      </div>
      <div className="body_m text-content_secondary">
        {I18n.t("The report will be generated at 8:00am")}
      </div>
    </div>
  );
};
